import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Login } from '../components/Login';
import { ProtectedRoute } from './ProtectedRoute';
import { AppShell } from '../components/Layout/AppShell';
import { OnboardingRedirect } from '../components/OnboardingRedirect';
import { HomeView } from '../pages/home/HomeView';
import { SessionsPage } from '../pages/sessions/SessionsPage';
import { CalendarPage } from '../pages/calendar/CalendarPage';
import { PatientsPage } from '../pages/patients/PatientsPage';
import { ProfilePage } from '../pages/profile/ProfilePage';
import { Derivaciones } from '../pages/Derivaciones';
import { NoAgendamientoEmbed } from '../pages/NoAgendamientoEmbed';
import { VacacionesEmbed } from '../pages/VacacionesEmbed';
import { MeetEmbebida } from '../pages/MeetEmbebida';
import { CleanPage } from '../pages/CleanPage';
import { CertActionPage } from '../pages/CertActionPage';
import { FarewellEmbed } from '../pages/FarewellEmbed';
import { KnowledgeBasePreviewPage } from '../pages/kb-preview/KnowledgeBasePreviewPage';
/** Redirects legacy paths preserving query params */
const LegacyRedirect = ({ to }: { to: string }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
};

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Root & backwards-compat redirect */}
      <Route path="/" element={<OnboardingRedirect />} />
      <Route path="/psychologist" element={<OnboardingRedirect />} />

      <Route path="/login" element={<Login />} />
      <Route path="/clean" element={<CleanPage />} />
      {/* Página pública para aprobar/rechazar certificados desde el email al equipo */}
      <Route path="/cert-action" element={<CertActionPage />} />
      {/* Preview público (sin login) del contenido de la knowledge base — usado por el backoffice */}
      <Route path="/kb-preview" element={<KnowledgeBasePreviewPage />} />

      {/* Protected layout shell */}
      <Route
        element={
          <ProtectedRoute requirePsychologist>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/home" element={<HomeView />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="/sessions/meet" element={<MeetEmbebida />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/calendar/time-off" element={<VacacionesEmbed />} />
        <Route path="/patients" element={<PatientsPage />} />
        <Route path="/patients/derivation" element={<Derivaciones />} />
        <Route path="/patients/no-schedule" element={<NoAgendamientoEmbed />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/farewell" element={<FarewellEmbed />} />
      </Route>

      {/* Legacy redirects — preserve query params */}
      <Route path="/derivaciones" element={<LegacyRedirect to="/patients/derivation" />} />
      <Route path="/noagendamiento" element={<LegacyRedirect to="/patients/no-schedule" />} />
      <Route path="/vacaciones" element={<LegacyRedirect to="/calendar/time-off" />} />
      <Route path="/meetEmbebida" element={<LegacyRedirect to="/sessions/meet" />} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export const routePaths = {
  home: '/home',
  login: '/login',
  sessions: '/sessions',
  calendar: '/calendar',
  patients: '/patients',
  profile: '/profile',
} as const;

export type RoutePath = typeof routePaths[keyof typeof routePaths];
